import React from 'react'
import {connect} from 'react-redux';
import Staff from './staff'
import EditStaff from './edit-staff'
import {getStaffMember, addStaff} from '../../actions/staff'
import './store-details.css'

const StaffList = (props) => {

  const onEditStaffClicked = (link, row, id) => {
    if(props.staff_member_id != id){
      props.dispatch(addStaff(link));
      props.dispatch(getStaffMember(link, row));
    }
  };

  let staffItems = [<h1>Loading...</h1>];

  if (props.fetched) {
    staffItems = [[]];
    props.staff.forEach((staff, index)=> {
      if(index > 0 && !(index % 3)){
        staffItems.push([]);
      }
      staffItems[staffItems.length-1].push(
        <Staff
          key={staff.id}
          staff={staff}
          row={staffItems.length-1}
          open={props.staff_member_id == staff.id}
          onEditStaffClicked={onEditStaffClicked}
          />
      )
    });

    if(!(staffItems[staffItems.length-1].length % 3)){
      staffItems.push([]);
    }
  }

  return (
    <div className="staff-list relationship">
      {staffItems.map((item, index) => {
        return (
          <div key={`container-${index}`}>
            <div className="row" key={`row-${index}`}>
              {item}
            </div>
            <div className="row" key={`edit-${index}`}>
              <EditStaff open={index === props.staff_member_row} staff_member_status={props.staff.status}/>
            </div>
          </div>
        )
      })}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    editStaffVisible: state.staff.editStaffVisible,
    staff_member_id: state.staff.staff_member_id,
    staff_member_row: state.staff.staff_member_row
  };
};

export default connect(mapStateToProps)(StaffList);


// WEBPACK FOOTER //
// ./src/components/store-details/staff-list.jsx